import { useEffect } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useNoticeBannersStackActions, useResponsive } from '@sg/garnish';

import { NoResults as NoResultsDesktop } from './NoResults.desktop';

export const NoResults = () => {
  const { formatMessage } = useIntl();
  const { currentBreakpoint } = useResponsive();
  const { push: addNoticeBanner } = useNoticeBannersStackActions();

  const message = formatMessage(messages.noResults);

  useEffect(() => {
    if (!currentBreakpoint.isXS) return;
    addNoticeBanner({ text: message, palette: 'neutral' });
  }, [message, currentBreakpoint.isXS, addNoticeBanner]);

  if (currentBreakpoint.isXS) return null;

  return <NoResultsDesktop message={message} />;
};

// ─── Messages ───────────────────────────────────────────────────────────────────

const messages = defineMessages({
  noResults: {
    defaultMessage: "Ah snap peas! We couldn't find any locations.",
    description: 'Account | Address Form | No search results',
  },
});
